import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/**  各个模块 */

import store from "@/store";

Vue.use(Router);
Router.prototype.goBack = function() {
  store.commit("UPDATE_ROUTER_IS_BACK", true);
  window.history.go(-1);
};
window.addEventListener(
  "popstate",
  () => {
    store.commit("UPDATE_ROUTER_IS_BACK", true);
  },
  false
);
export default new Router({
  routes: [
    {
      path: "/",
      redirect() {
        // return '/OldNew';
        return "/progress";

        // return '/recommend';
      },
    },
    {
      path: "/auditDetail",
      name: "auditDetail",
      component: () => import("@/pages/Old-New/auditDetail"),
      meta: {
        trust: true,
      },
    },
    {
      path: "/recommend",
      name: "Recommend",
      component: () => import("@/pages/recommend/index"),
      meta: {
        trust: true,
      },
    },

    {
      path: "/page1",
      name: "page1",
      component: () => import("@/pages/appTest/test1"),
    },
    {
      path: "/page2",
      name: "page2",
      component: () => import("@/pages/appTest/test2"),
    },
    {
      path: "/validation",
      name: "validation",
      component: () => import("@/pages/progress/validation"),
    },
    {
      path: "/takeTo",
      name: "takeTo",
      component: () => import("@/pages/progress/takeTo"),
    },
    // 置业顾问端tag
    {
      path: "/tagList",
      name: "tagList",
      component: () => import("@/pages/progress/tagList"),
    },
    {
      path: "/progress",
      name: "progress",
      component: () => import("@/pages/progress/progress"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/progressDetail",
      name: "progressDetail",
      component: () => import("@/pages/progress/progressDetail2"),
    },
    {
      path: "/callMatch",
      name: "callMatch",
      component: () => import("@/pages/progress/callMatch"),
    },
    {
      path: "/userInfo",
      name: "userInfo",
      component: () => import("@/pages/progress/userInfo"),
    },
    {
      path: "/recommendInfo",
      name: "recommendInfo",
      component: () => import("@/pages/recommendInfo/index"),
      meta: {
        trust: true,
      },
    },
    {
      path: "/agreement",
      name: "agreement",
      component: () => import("@/pages/agreement/index"),
    },
    {
      path: "/OldNew",
      name: "OldNew",
      // component: () => import("@src/old-bring-new/pages/Old-New/oldNew"),
      component: () => import("@src/old-bring-new/pages/OldNew2/oldNew"),
      meta: {
        trust: true,
        keepAlive: true,
      },
    },
    {
      path: "/oldnew-search",
      name: "oldnew-search",
      component: () =>
        import("@src/old-bring-new/pages/OldNew2/OldNewComponent/search"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/oldNewDetail",
      name: "oldNewDetail",
      component: () => import("@src/old-bring-new/pages/OldNew2/oldNewDetail"),
      meta: {
        trust: true,
      },
    },
    {
      path: "/Customer",
      name: "Customer",
      component: () => import("@src/old-bring-new/pages/Old-New/customer"),
      meta: {
        trust: true,
      },
    },
    {
      path: "/mine",
      name: "Mine",
      component: () => import("@/pages/Mine/index"),
      meta: {
        title: "我的",
        showTabbar: true,
      },
    },
    {
      path: "/author",
      name: "Author",
      component: () => import("@src/_common/pages/Author"),
      meta: {
        trust: true,
        noNeedLogin: true,
      },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@src/_common/pages/Login"),
      meta: {
        trust: true,
        noNeedLogin: true,
      },
    },
    {
      path: "*",
      name: "404",
      component: () => import("@src/_common/pages/404"),
      meta: {
        trust: true,
        noNeedLogin: true,
        title: "404",
      },
    },
  ],
});
